import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { GenericLinkComponent, GenericLinkComponentService } from '@spartacus/storefront';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-efa-generic-link',
    templateUrl: './efa-generic-link.component.html',
    imports: [NgTemplateOutlet, RouterLink]
})
export class EfaGenericLinkComponent extends GenericLinkComponent {

  constructor(
    protected router: Router,
    protected service: GenericLinkComponentService
  ) {
    super(router, service);
  }
}
